import { Link } from "react-router-dom";
import Footer from "../components/footer";
import Header from "../components/header";
import { useEffect, useState } from "react";


const Home = () => {

    const handleRedirect = (url) => {
        window.open(url, "_blank"); // Redirect to the specified URL
    };

    const [isScrolled, setIsScrolled] = useState(false);
    
        const [isOpenNav, setIsOpenNav] = useState(false);
    
        const toggleNav = () => {
            setIsOpenNav(!isOpenNav);
        };
    
    
        useEffect(() => {
    
    
    
            const handleScroll = () => {
                const scrollTop = window.scrollY;
                if (scrollTop > 0) {
                    setIsScrolled(true);
                } else {
                    setIsScrolled(false);
                }
            }
            window.addEventListener('scroll', handleScroll);
            return () => {
                window.removeEventListener('scroll', handleScroll);
            };
    
        }, []);

    return (
        <>
            <nav className={`navbar navbar-expand-lg navbar-custom home_nav navbar-light ${isScrolled ? 'fixed-top' : ''}`} >
                <div className="container">
                    <Link className="navbar-brand mr-auto" to="/">
                        <img src="/images/logo.svg" alt="" />
                    </Link>

                    <button className={`navbar-toggler ${isOpenNav ? '' : 'collapsed'}`} onClick={toggleNav} type="button" data-toggle="collapse" data-target="#navbarToggler" aria-controls="navbarToggler" aria-expanded="false" aria-label="Toggle navigation">
                        <svg className={`ham hamRotate ham1 ${isOpenNav ? 'active' : ''}`} viewBox="0 0 100 100" width="60"><path className="line top" d="m 30,33 h 40 c 0,0 9.044436,-0.654587 9.044436,-8.508902 0,-7.854315 -8.024349,-11.958003 -14.89975,-10.85914 -6.875401,1.098863 -13.637059,4.171617 -13.637059,16.368042 v 40"></path><path class="line middle" d="m 30,50 h 40"></path><path class="line bottom" d="m 30,67 h 40 c 12.796276,0 15.357889,-11.717785 15.357889,-26.851538 0,-15.133752 -4.786586,-27.274118 -16.667516,-27.274118 -11.88093,0 -18.499247,6.994427 -18.435284,17.125656 l 0.252538,40"></path></svg>
                    </button>

                    <div className={`collapse navbar-collapse justify-content-start justify-content-sm-end ${isOpenNav ? 'show' : ''}`} id="navbarToggler">
                        <ul className="navbar-nav ml-auto">
                            <li><Link className="nav-link active" to="/">Home</Link></li>
                            <li><Link className="nav-link" to="/aboutUs">About Us</Link></li>
                            <li><Link className="nav-link" to="/contact">Contact</Link></li>
                        </ul>
                    </div>
                </div>
            </nav>
            <section className="section-home">
                <div className="overlay d-flex justify-content-center align-items-center">
                    <div className="overlay-wrap section-head">
                        <h2 data-aos="zoom-in" data-aos-duration="500">Ez Scan Go: Revolutionize Checkout. <br />No Lines, Just Scan and Go!</h2>
                        <span class="mb-2" data-aos="zoom-in" data-aos-duration="1000">Fast, secure, and efficient checkout for your favorite products.</span>
                        {/* <a href="#" className="btnstart" data-aos="fade-up" data-aos-duration="500">Download for iOS</a>
                        <a href="#" className="btnstart" data-aos="fade-up" data-aos-duration="800">Download for Android</a> */}
                    </div>
                </div>
            </section>

            <section className="bg-white">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-7 align-items-center d-flex p-5">
                            <div>
                                <p className="display-6 fw-bold" data-aos="fade-up" data-aos-duration="500">Checkout Made Easy</p>
                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="boxsec" data-aos="fade-up" data-aos-duration="800">
                                            <h4 className="title">Quick Checkout</h4>
                                            <p>Say goodbye to long lines! With Ez Scan Go, you can complete your purchase in seconds, saving valuable time during your shopping when in a hurry.</p>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="boxsec" data-aos="fade-up" data-aos-duration="1100">
                                            <h4 className="title">Simple QR Scanning</h4>
                                            <p>Our intuitive app allows you to effortlessly scan QR codes on products, making the purchasing process a breeze.</p>
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <div className="boxsec" data-aos="fade-up" data-aos-duration="1400">
                                            <h4 className="title">Data Protection</h4>
                                            <p>Your personal information remains secure with our advanced encryption methods, ensuring your privacy is never compromised.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-5 p-5" data-aos="fade-up" data-aos-duration="1000">
                            <img src="/images/site-img-1.jpg" class="w-100 mt-4 mb-4" />
                        </div>
                    </div>
                </div>
            </section>

            <section className="dark_theam">
                <div className="container">
                    <h2 className="display-6 mb-4" data-aos="fade-up" data-aos-duration="500">Streamline Your Business : Designed for small & mid sized businesses. Implement scan & go functionality at no/low cost and compete with big business.</h2>
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="boxlite" data-aos="fade-up" data-aos-duration="800">
                                <div className="h4">Daily Reports</div>
                                <p className="fw-light">Access comprehensive daily sales and quantity reports, giving you valuable insights into your business performance.</p>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="boxlite" data-aos="fade-up" data-aos-duration="1100">
                                <div className="h4">Encrypted Data</div>
                                <p className="fw-light">Rest easy knowing that all bank and merchant data is securely encrypted, protecting your sensitive information.</p>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="boxlite" data-aos="fade-up" data-aos-duration="1400">
                                <div className="h4">No Integration Required</div>
                                <p className="fw-light">Our standalone system doesn't require integration with your existing inventory system, making setup quick and hassle-free.</p>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="boxlite" data-aos="fade-up" data-aos-duration="1700">
                                <div className="h4">Free Solution</div>
                                <p className="fw-light">(Introductory Offer) Implement a cost-effective solution for selling fast-moving items, perfect for businesses of all sizes.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="dark_theam">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4" data-aos="fade-up" data-aos-duration="500">
                            <img src="images/site-img-2.jpg" class="w-100" />
                        </div>
                        <div className="col-lg-8 ps-5 pe-5">
                            <h2 className="display-6 mb-4" data-aos="fade-up">Shopper Experience</h2>
                            <ul className="numlist">
                                <li data-aos="fade-up" data-aos-duration="800">
                                    <div className="h4">Scan Code</div>
                                    <p>Simply open the Ez Scan Go app and scan the QR code displayed on the product you wish to purchase.</p>
                                </li>
                                <li data-aos="fade-up" data-aos-duration="1100">
                                    <div className="h4">Confirm Purchase</div>
                                    <p>Review your item and price, then confirm your purchase with a single tap within the app.</p>
                                </li>
                                <li data-aos="fade-up" data-aos-duration="1400">
                                    <div className="h4">Pay and Go</div>
                                    <p>Complete your transaction securely through the app and walk out with your purchase - no lines, no waiting</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <section className="dark_theam">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 ps-5 pe-5">
                            <h2 className="display-6 mb-4" data-aos="fade-up" data-aos-duration="500">Merchant Experience</h2>
                            <ul className="arrowlist">
                                <li data-aos="fade-up" data-aos-duration="800">
                                    <div className="conter"><h2></h2></div>
                                    <div>
                                        <div className="h4">Add Product & Generate QR Codes</div>
                                        <p>Add the products that you want to sell through Ez Scan Go platform & print the generated QR Code</p>
                                    </div>
                                </li>
                                <li data-aos="fade-up" data-aos-duration="800">
                                    <div className="conter"><h2></h2></div>
                                    <div>
                                        <div className="h4">Display QR Codes</div>
                                        <p>Generate and Place QR codes next to your fast-moving items for easy customer access.</p>
                                    </div>
                                </li>
                                <li data-aos="fade-up" data-aos-duration="1100">
                                    <div className="conter"><h2></h2></div>
                                    <div>
                                        <div className="h4">Track Sales</div>
                                        <p>Monitor real-time sales data through our user-friendly merchant portal.</p>
                                    </div>
                                </li>
                                <li data-aos="fade-up" data-aos-duration="1700">
                                    <div className="conter"><h2></h2></div>
                                    <div>
                                        <div className="h4">Receive Payments</div>
                                        <p>Funds are securely transferred to your verified bank account on a regular schedule.</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div className="col-lg-4" data-aos="fade-up" data-aos-duration="800">
                            <img src="images/site-img-3.jpg" className="w-100" />
                        </div>
                    </div>
                </div>
            </section>

            <section className="dark_theam">
                <div className="container">
                    <div className="row">
                        <h2 className="display-6 mb-4 text-center" data-aos="fade-up" data-aos-duration="500">Why Choose Ez Scan Go for Your Business?</h2>
                        <div className="col-lg-12">
                            <ul className="pyramidlist">
                                <li data-aos="fade-up" data-aos-duration="800">
                                    <div className="pyramid py-1"><h2>1</h2></div>
                                    <div>
                                        <div className="h4">Increased Sales</div>
                                        <p>Eliminate long lines and boost customer satisfaction</p>
                                    </div>
                                </li>
                                <li data-aos="fade-up" data-aos-duration="1100">
                                    <div className="pyramid py-2"><h2>2</h2></div>
                                    <div>
                                        <div className="h4">Cost-Effective</div>
                                        <p>Affordable solution for businesses of all sizes</p>
                                    </div>
                                </li>
                                <li data-aos="fade-up" data-aos-duration="1400">
                                    <div className="pyramid py-3"><h2>3</h2></div>
                                    <div>
                                        <div className="h4">Versatile Application</div>
                                        <p>Ideal for convenience stores, gas stations, stadiums, fairs, airports etc</p>
                                    </div>
                                </li>
                                <li data-aos="fade-up" data-aos-duration="1700">
                                    <div className="pyramid py-4"><h2>4</h2></div>
                                    <div>
                                        <div className="h4">Easy Implementation</div>
                                        <p>Quick setup with no technical knowledge required</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <section className="dark_theam">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 ps-5 pe-5">
                            <h2 className="display-6 mb-4" data-aos="fade-up" data-aos-duration="500">Robust Security Features</h2>
                            <div className="row">
                                <div className="col-lg-6 pt-3 pb-3" data-aos="fade-up" data-aos-duration="800">
                                    <div className="display-5"><i class="bi bi-shield-fill-check"></i></div>
                                    <div className="h4">Encrypted Data</div>
                                    <p>All merchant and user data is fully encrypted, ensuring the highest level of protection for sensitive information.</p>
                                </div>
                                <div className="col-lg-6 pt-3 pb-3" data-aos="fade-up" data-aos-duration="1100">
                                    <div className="display-5"><i class="bi bi-envelope-check-fill"></i></div>
                                    <div className="h4">Secure Verification</div>
                                    <p>Bank account verification is conducted securely via 2 factor authentication, adding an extra layer of safety to your financial transactions.</p>
                                </div>
                                <div className="col-lg-6 pt-3 pb-3" data-aos="fade-up" data-aos-duration="1400">
                                    <div className="display-5"><i class="bi bi-unlock-fill"></i></div>
                                    <div className="h4">Encrypted Communication</div>
                                    <p>All communication between the app and backend is encrypted, safeguarding data transfer at every step.</p>
                                </div>
                            </div>

                        </div>
                        <div className="col-lg-4" data-aos="fade-up" data-aos-duration="800">
                            <img src="images/site-img-4.jpg" class="w-100" />
                        </div>
                    </div>
                </div>
            </section>

            <section className="dark_theam">
                <div className="col-lg-10 m-auto">
                    <div className="row">
                        <h2 className="display-6 mb-4" data-aos="fade-up" data-aos-duration="500">Easy Setup for Merchants</h2>
                        <div className="col-lg-12">
                            <ul className="pyramidlist">
                                <li data-aos="fade-up" data-aos-duration="800">
                                    <div className="squire sq-1"><h2>1</h2></div>
                                    <div>
                                        <div className="h4">Register</div>
                                        <p>Sign up on our secure merchant portal</p>
                                    </div>
                                </li>
                                <li data-aos="fade-up" data-aos-duration="1100">
                                    <div className="squire sq-2"><h2>2</h2></div>
                                    <div>
                                        <div className="h4">Add Products</div>
                                        <p>Add your fast-moving items to the system</p>
                                    </div>
                                </li>
                                <li data-aos="fade-up" data-aos-duration="1400">
                                    <div className="squire sq-3"><h2>3</h2></div>
                                    <div>
                                        <div className="h4">Generate QR Codes</div>
                                        <p>Create unique QR codes for each product</p>
                                    </div>
                                </li>
                                <li data-aos="fade-up" data-aos-duration="1700">
                                    <div className="squire sq-4"><h2>4</h2></div>
                                    <div>
                                        <div className="h4">Display and Sell</div>
                                        <p>Place QR codes and start selling via Ez Scan Go payments</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <section className="light_theam">
                <div className="container">
                    <div className="light-box p-5">
                        <h2 data-aos="fade-up" data-aos-duration="500">Benefits for Shoppers: Shop Smarter, Not Harder</h2>
                        <div className="row">
                            <div className="col-lg-4">
                                <div className="boxsec" data-aos="fade-up" data-aos-duration="800">
                                    <div className="h4">Skip the line</div>
                                    <p>Skip the lines and enjoy a faster, more efficient shopping experience with our innovative scan-and-go technology.</p>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="boxsec" data-aos="fade-up" data-aos-duration="1100">
                                    <div className="h4">Secure Payments</div>
                                    <p>Make worry-free purchases with our encrypted payment system, ensuring your financial information stays protected.</p>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="boxsec" data-aos="fade-up" data-aos-duration="1400">
                                    <div className="h4">For people in hurry</div>
                                    <p>Enjoy the convenience of Scan & Go at various locations including convenience stores, gas stations, stadiums, fairs, airports etc.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="dark_theam">
                <div className="container">
                    <h2 className="display-6 mb-4" data-aos="fade-up" data-aos-duration="500">Frequently Asked Questions</h2>
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="boxlite" data-aos="fade-up" data-aos-duration="800">
                                <div className="h4">How does Ez Scan Go work?</div>
                                <p className="fw-light">Ez Scan Go allows users to scan QR codes on products, confirm purchases through the app, and complete transactions without waiting in line.</p>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="boxlite" data-aos="fade-up" data-aos-duration="1100">
                                <div className="h4">Is my data secure?</div>
                                <p className="fw-light">Yes, all user and merchant data is fully encrypted, ensuring the highest level of security for your personal and financial information.</p>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="boxlite" data-aos="fade-up" data-aos-duration="1400">
                                <div className="h4">How do merchants update prices?</div>
                                <p className="fw-light">Merchants can easily update prices and product details through our user-friendly merchant app, requiring no complex integrations.</p>
                            </div>
                        </div>
                        <div className="col-lg-6" data-aos="fade-up" data-aos-duration="1700">
                            <div className="boxlite">
                                <div className="h4">Where can I use Ez Scan Go?</div>
                                <p className="fw-light">Ez Scan Go can be used at participating locations including convenience stores, gas stations, stadiums, fairs, airports etc in our pilot cities.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="bg-2">
                <div className="container">
                    <h2 className="display-6 mb-4 text-white" data-aos="fade-up" data-aos-duration="500">Enhanced Security Measures</h2>
                    <div className="row">
                        <div className="col-lg-4">
                            <div className="boxsec" data-aos="fade-up" data-aos-duration="800">
                                <div className="h4 text-white">TLS Encryption</div>
                                <p className="text-white">All communication between the app, servers, and merchant portals is secured using Transport Layer Security (TLS) encryption.</p>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="boxsec" data-aos="fade-up" data-aos-duration="1100">
                                <div className="h4 text-white">Two-Factor Authentication</div>
                                <p className="text-white">Merchants benefit from an additional layer of security with two-factor authentication for account access.</p>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="boxsec" data-aos="fade-up" data-aos-duration="1400">
                                <div className="h4 text-white">Regular Security Audits</div>
                                <p className="text-white">We conduct frequent security assessments to identify and address potential vulnerabilities promptly.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="dark_theam">
                <div className="container">
                    <h2 className="display-6 mb-4" data-aos="fade-up" data-aos-duration="500">The Ez Scan Go Difference</h2>
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="h4" data-aos="fade-up" data-aos-duration="800">For Shoppers</div>
                            <p className="fw-light">
                                <ul data-aos="fade-up" data-aos-duration="800">
                                    <li>No more waiting in long lines</li>
                                    <li>Quick and easy purchases with a simple scan</li>
                                    <li>Secure, contactless transactions</li>
                                    <li>Works at a variety of popular locations</li>
                                </ul>
                            </p>
                        </div>
                        <div className="col-lg-6">
                            <div className="h4" data-aos="fade-up" data-aos-duration="1100">For Merchants</div>
                            <p className="fw-light" >
                                <ul data-aos="fade-up" data-aos-duration="1100">
                                    <li>Increased sales and faster checkout</li>
                                    <li>Reduced labor costs for checkout</li>
                                    <li>Easy implementation with minimal setup</li>
                                    <li>Real-time sales data and analytics</li>
                                </ul>
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="dark_theam">
                <div className="container">
                    <h2 className="display-6 mb-4" data-aos="fade-up" data-aos-duration="500">Connect with Ez Scan Go</h2>
                    <div className="row">
                        <div className="col-2"></div>
                        <div className="col-3">
                            <div className="display-5" data-aos="fade-up" data-aos-duration="600" style={{ fontFamily: "Arial, sans-serif", fontWeight: "bold", cursor: "pointer" }} onClick={() => handleRedirect("https://x.com/EzScanGo")}>X</div>
                        </div>
                        <div className="col-3">
                            <div className="display-5" data-aos="fade-up" data-aos-duration="800"><i className="fab fa-instagram" style={{ cursor: "pointer" }} onClick={() => handleRedirect("https://www.instagram.com/ezscango/")}></i></div>
                        </div>
                        <div className="col-3">
                            <div className="display-5" data-aos="fade-up" data-aos-duration="1000"><i className="fab fa-linkedin" style={{ cursor: "pointer" }} onClick={() => handleRedirect("https://www.linkedin.com/company/EzScanGo")}></i></div>
                        </div>
                        <div className="col-lg-12"></div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    )

};
export default Home;